import * as routes from '@educabot/educablocks-cosmos';

/**
 * A dónde se compila cuando no se usa la ruta de cosmos, que en la práctica es el
 * desarrollo local. Staging y no producción: lo que se prueba en desarrollo suele
 * ir de la mano de un cambio en el builder, y mandarlo al de producción compila
 * contra algo distinto de lo que se está por publicar.
 */
const BUILDER_FALLBACK = 'https://builder.staging.educabot.com';

const BUILDER_URIS = {
  eb_build: routes.ebBuildUri || `${BUILDER_FALLBACK}/eb_build`,
  esp_build: routes.espBuildUri || `${BUILDER_FALLBACK}/esp_build`,
  microbit_build: routes.microbitBuildUri || `${BUILDER_FALLBACK}/microbit_build`,
};

export const isESPBoard = (compilerBoard = '') => compilerBoard.startsWith('esp32:')
  || compilerBoard.startsWith('esp8266:')
  || compilerBoard.startsWith('esp32-bluepad32:');

/**
 * Cosmos arma las tres rutas como base + endpoint, asi que el fallback se compone
 * igual y alcanza con una sola base para los tres builders.
 *
 * En desarrollo local se apunta al fallback en vez de a la ruta de cosmos. Electron
 * gana sobre las dos: ahi el builder corre en el proceso local.
 */
const getBuildUri = (endpoint, httpElectronConnection) => {
  if (process.env.IS_ELECTRON) return `${httpElectronConnection}/${endpoint}`;
  if (process.env.NODE_ENV === 'development') return `${BUILDER_FALLBACK}/${endpoint}`;
  return BUILDER_URIS[endpoint];
};

/**
 * Where a board's code gets compiled, and with which body.
 *
 * Every transport asks the same three builders — eb_build, microbit_build and
 * esp_build — so the choice lives here and not next to each caller: the electron
 * ports, the cosmos routes and the builder fallback are then read from one place,
 * and pointing any of them at a local builder is a single edit.
 *
 * The board is taken as an argument and not from an agent's own field because the
 * upload calls receive theirs from the caller, and that one is the board being
 * compiled right now.
 */
export const getBuildTarget = (compilerBoard, code = '', httpElectronConnection = '') => {
  const board = compilerBoard || 'arduino';
  const text = encodeURIComponent(code);

  if (board === 'microbit') {
    return {
      uri: getBuildUri('microbit_build', httpElectronConnection),
      params: `text=${text}`,
    };
  }

  if (isESPBoard(board)) {
    return {
      uri: getBuildUri('esp_build', httpElectronConnection),
      params: `board=${board}&text=${text}`,
    };
  }

  return {
    uri: getBuildUri('eb_build', httpElectronConnection),
    params: `board=${board}&text=${text}`,
  };
};
